import { render } from "./AppointmentsTable.vue?vue&type=template&id=bc710cde&scoped=true"
import script from "./AppointmentsTable.vue?vue&type=script&lang=js"
export * from "./AppointmentsTable.vue?vue&type=script&lang=js"

import "./AppointmentsTable.vue?vue&type=style&index=0&id=bc710cde&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc710cde"]])

export default __exports__